import { Admin, Resource, nanoLightTheme} from 'react-admin';

// Sample CRUD components
import { UserList, UserEdit, UserCreate } from './accounts';
import createDataProvider from './dataProvider';
import { QuestionnaireList, QuestionnaireResponseList } from './questionnaires';
import { FindingList } from './findings';
import { AssignmentCreate, AssignmentEdit, AssignmentList, WebsiteList } from './assignments';


const AdminPage = () => {
  return (
    <Admin basename="/admin" dataProvider={createDataProvider()} theme={nanoLightTheme}>
      <Resource name="accounts" list={UserList} edit={UserEdit} create={UserCreate} />
      <Resource name="questionnaires" list={QuestionnaireList} />
      <Resource name="questionnaire/responses" list={QuestionnaireResponseList} />
      <Resource name="findings" list={FindingList} />
      <Resource name="websites" list={WebsiteList} />
      <Resource name="assignments" list={AssignmentList} edit={AssignmentEdit} create={AssignmentCreate} />
    </Admin>
  );
};

export default AdminPage;